<template>
  <div class="datatable-bulk-actions" :class="{ 'datatable-bulk-actions--total': total > 0 }">
    <div class="d-flex justify-content-between">
      <div v-if="total > 0" class="bulk-actions__options">
        <div class="bulk-actions__option" :class="{ 'active': selected === BULK_UPDATE.ACTION_TARGET.SELECTED }">
          <input
            v-if="rows.length !== total"
            v-model="selected"
            type="radio"
            id="action-target-selected"
            name="action-target"
            class="mr10"
            :value="BULK_UPDATE.ACTION_TARGET.SELECTED"
          >
          <label for="action-target-selected">{{label}}</label>
        </div>
        <div v-if="rows.length !== total && type !== 'author'" class="bulk-actions__option" :class="{ 'active': selected === BULK_UPDATE.ACTION_TARGET.FILTERED }">
            <input
              v-model="selected"
              type="radio"
              id="action-target-filtered"
              name="action-target"
              class="mr10"
              :value="BULK_UPDATE.ACTION_TARGET.FILTERED"
            >
            <label for="action-target-filtered">All filtered {{$tc('datatable.bulk_actions.resource_types.' + this.type, total).toLowerCase()}} ({{total}})</label>
          </div>
      </div>
      <span v-else>{{label}}</span>

      <div class="text-marine cursor-pointer" @click="onBulk('cancel')">
        <i class="fas fa-times mr5" aria-hidden="true" />
      </div>
    </div>
    

    <div class="actions" :class="{ 'mt20': total > 0 }">
      <template v-for="action in formattedActions">
        <dropdown-button
          v-if="action.options"
          :key="action.type + '-dropdown'"
          :options="action.options"
          :icon="action.icon"
          :label="$t(resourceTranslationsPath + '.' + action.type)"
          customCss="bulk-action-dropdown text-gray text-sm mr15"
          :disabledProp="!action.enabled"
          v-on="dropdownListeners(action)"
        />
        <div v-else :key="action.type + '-action'" class="d-flex align-items-center text-gray text-sm cursor-pointer mr15 action" :class="{ 'disabled': !action.enabled, [action.class]: true }" @click="onBulk(action.type)">
          <i v-if="action.icon" :class="action.icon" class="mr5 text-xs"></i>
          <span>{{$t(resourceTranslationsPath + "." + action.type)}}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { BULK_UPDATE } from '../config/const';
import dropdownButton from './dropdown-button';

export default {
  props: {
    type: {
      type: String,
      default: () => 'resource'
    },
    actions: {
      type: Array,
      required: true,
      validator: prop => prop.every(e => typeof e === 'string' || (typeof e === 'object' && e.type))
    },
    rows: {
      type: Array,
      required: true
    },
    total: {
      type: Number,
      default: () => 0
    },
    showAllOption: {
      type: Boolean,
      default: () => false
    },
    showCancel: {
      type: Boolean,
      default: () => false
    },
    translationsPath: {
      type: String
    },
    value: {
      type: String
    }
  },

  components: {
    dropdownButton
  },

  data: function () {
    return {
      BULK_UPDATE,
      selected: this.value || BULK_UPDATE.ACTION_TARGET.SELECTED
    }
  },

  watch: {
    value(val) {
      if (val && val !== this.selected) {
        this.selected = val;
      }
    },
    selected (val) {
      this.$emit('input', val)
    }
  },

  computed: {
    label () {
      return `${this.rows.length} ${this.$tc('datatable.bulk_actions.resource_types.' + this.type, this.rows.length).toLowerCase()} selected`;
    },

    resourceTranslationsPath () {
      return this.translationsPath || (this.type + ".actions");
    },

    formattedActions () {
      return this.actions.map(a => {
        const data = {
          type: '',
          enabled: true
        }

        if (typeof a === 'string') {
          data.type = a;
        } else if (typeof a === 'object') {
          data.type = a.type;
          data.enabled = typeof a.enabled === 'undefined' ? true : a.enabled;
          data.class = a.class || '';
          data.icon = a.icon;
          data.options = a.options;
        }
        
        return data;
      })
    }
  },

  methods: {
    onBulk (action) {
      this.$emit(action);
    },

    dropdownListeners (action) {
      const listeners = {};
      const options = action.options || [];
      for (let i = 0; i < options.length; i++) {
        const actionName = options[i].action;
        listeners[actionName] = () => this.onBulk(actionName);
      }
      return listeners;
    }
  }
}
</script>

<style lang="scss">
  @import '../styles/components/datatable_bulk_actions';
</style>